"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WordCount =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(WordCount, _PureComponent);

  function WordCount() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, WordCount);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WordCount)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      length: 0
    });

    _defineProperty(_assertThisInitialized(_this), "targetRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "getInitLength", function () {
      var length = _this.getLength();

      _this.setState({
        length: length
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getLength", function () {
      var current = _this.targetRef.current;
      var length = 0;

      if (current && current.value) {
        length = current.value.length;
      }

      return length;
    });

    _defineProperty(_assertThisInitialized(_this), "getWordCount", function (e, data) {
      var length = _this.getLength();

      if ((0, _lib.objHasKeys)(data)) {
        length = data.value.length;
      }

      _this.setState({
        length: length
      }, function () {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            max = _this$props.max;

        if (onChange) {
          onChange(e, data, {
            length: length,
            max: max
          });
        }
      });
    });

    return _this;
  }

  _createClass(WordCount, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getInitLength();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          max = _this$props2.max;
      var length = this.state.length;
      return (0, _lib.getRenderProps)(children, {
        maxLength: max,
        targetRef: this.targetRef,
        onChange: this.getWordCount,
        value: length,
        wordNode: _react.default.createElement("p", {
          style: {
            fontSize: '0.8em',
            paddingTop: '0.25rem'
          }
        }, "".concat(length, " / ").concat(max))
      });
    }
  }]);

  return WordCount;
}(_react.PureComponent);

exports.default = WordCount;

_defineProperty(WordCount, "propTypes", {
  children: _common.customPropTypes.render.isRequired,
  max: _propTypes.default.number,
  onChange: _propTypes.default.func
});

_defineProperty(WordCount, "defaultProps", {
  max: null,
  onChange: null
});